export default "__VITE_ASSET__CttEJq2s__"